import React from 'react';
import Icon from '../../../components/AppIcon';

const NetworkStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {stats?.map((stat) => (
        <div
          key={stat?.id}
          className="bg-card rounded-lg p-4 md:p-6 border border-border hover:shadow-lg transition-all duration-300"
        >
          <div className="flex items-center gap-3 mb-3">
            <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center ${stat?.bgColor}`}>
              <Icon name={stat?.icon} size={20} color={stat?.iconColor} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs md:text-sm text-muted-foreground truncate">{stat?.label}</p>
            </div>
          </div>
          <div className="space-y-1">
            <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground font-headline">
              {stat?.value}
            </p>
            {stat?.change && (
              <div className="flex items-center gap-1">
                <Icon
                  name={stat?.change > 0 ? 'TrendingUp' : 'TrendingDown'}
                  size={14}
                  color={stat?.change > 0 ? 'var(--color-success)' : 'var(--color-error)'}
                />
                <span
                  className={`text-xs md:text-sm font-medium ${
                    stat?.change > 0 ? 'text-success' : 'text-error'
                  }`}
                >
                  {Math.abs(stat?.change)}% vs last year
                </span>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default NetworkStats;